export const appsManifestPrivateSymbol = Symbol();
